import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const ClockIcon = ({ theme, type }) => {
  const iconColor =
    type === "alternative" ? theme.onSecondaryColor : theme.primaryColor;
  return (
    <Icon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
      >
        <g fill="none" fillRule="nonzero">
          <g fill={iconColor}>
            <path d="M25.039 16.817a.352.352 0 0 0 .352-.352v-2.986a.352.352 0 1 0-.704 0v2.986c0 .194.157.352.352.352zM30.824 19.229a.352.352 0 0 0-.497 0l-4.137 4.095A2.046 2.046 0 0 0 25 22.94c-.421 0-.832.13-1.176.373l-2.817-2.848a.352.352 0 0 0-.5.496l2.817 2.849A2.056 2.056 0 0 0 25 27.06a2.056 2.056 0 0 0 1.687-3.236l4.133-4.106a.352.352 0 0 0 .004-.49zm-4.87 6.732a1.408 1.408 0 0 1-.954.395 1.356 1.356 0 1 1 0-2.712 1.356 1.356 0 0 1 .947 2.317h.007zM24.961 33.183a.352.352 0 0 0-.352.352v2.986a.352.352 0 0 0 .704 0v-2.986a.352.352 0 0 0-.352-.352zM16.465 25.313a.352.352 0 1 0 0-.704h-2.986a.352.352 0 0 0 0 .704h2.986zM33.535 24.687a.352.352 0 0 0 0 .704h2.986a.352.352 0 0 0 0-.704h-2.986z" />
            <path d="M37.887 18.493a.353.353 0 0 0-.63.317A13.732 13.732 0 0 1 25 38.732h-.063a13.732 13.732 0 0 1-9.606-23.486A13.64 13.64 0 0 1 25 11.268h.063a13.732 13.732 0 0 1 9.652 4.031h-2.842a.352.352 0 1 0 0 .705h3.842a.352.352 0 0 0 .352-.353V11.81a.352.352 0 1 0-.704 0v3.14a14.454 14.454 0 0 0-10.3-4.387H25a14.437 14.437 0 0 0-10.254 24.599 14.342 14.342 0 0 0 10.19 4.275H25a14.437 14.437 0 0 0 12.887-20.944z" />
            <path d="M17.606 17.035l-.426-.43a.352.352 0 1 0-.5.497l.426.43a.352.352 0 1 0 .5-.497zM16.856 33.426c.092 0 .18-.037.246-.102l.43-.426a.354.354 0 1 0-.497-.504l-.43.426a.352.352 0 0 0 .247.603l.004.003zM32.394 32.465a.352.352 0 0 0 0 .496l.426.43a.352.352 0 1 0 .5-.497l-.426-.43a.352.352 0 0 0-.5 0zM14.845 21.127a.352.352 0 1 0 .275-.648l-.557-.233a.352.352 0 0 0-.27.648l.552.233zM20.423 35.915a.352.352 0 0 0 .46-.186l.244-.574a.352.352 0 0 0-.648-.271l-.233.556a.352.352 0 0 0 .177.475zM35.155 28.873a.352.352 0 0 0-.271.648l.556.233a.352.352 0 1 0 .275-.648l-.56-.233zM20.887 15.296a.352.352 0 0 0 .328-.486l-.23-.56a.352.352 0 1 0-.65.268l.228.56a.352.352 0 0 0 .324.218zM14.81 28.789l-.56.229a.352.352 0 1 0 .268.651l.56-.229a.352.352 0 0 0-.268-.651zM28.979 34.729a.352.352 0 0 0-.194.458l.23.56a.352.352 0 0 0 .65-.268l-.228-.56a.352.352 0 0 0-.458-.19z" />
          </g>
          <path
            fill={iconColor}
            d="M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0c1.275 0 2.539.096 3.783.284C40.918 2.127 50 12.602 50 25c0 13.807-11.193 25-25 25zm0-.704c13.418 0 24.296-10.878 24.296-24.296 0-12.049-8.827-22.229-20.618-24.02A24.49 24.49 0 0 0 25 .705C11.582.704.704 11.582.704 25S11.582 49.296 25 49.296z"
          />
        </g>
      </svg>
    </Icon>
  );
};

ClockIcon.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string
};

ClockIcon.defaultProps = {
  type: ""
};

export default withTheme(ClockIcon);
